import { render, staticRenderFns } from "./voucher.vue?vue&type=template&id=6215fda8&scoped=true&"
var script = {}
import style0 from "./voucher.vue?vue&type=style&index=0&id=6215fda8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6215fda8",
  null
  
)

export default component.exports